import type { SVGProps } from 'react';

const IconImageFill = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M4.5 17C4.0875 17 3.73437 16.8507 3.44062 16.5521C3.14687 16.2535 3 15.9028 3 15.5V4.5C3 4.09722 3.14687 3.74653 3.44062 3.44792C3.73437 3.14931 4.0875 3 4.5 3H15.5C15.9125 3 16.2656 3.14931 16.5594 3.44792C16.8531 3.74653 17 4.09722 17 4.5V15.5C17 15.9028 16.8531 16.2535 16.5594 16.5521C16.2656 16.8507 15.9125 17 15.5 17H4.5ZM6.25 14H13.754C13.9041 14 14.0139 13.9306 14.0833 13.7917C14.1528 13.6528 14.1389 13.5208 14.0417 13.3958L11.7917 10.3958C11.7188 10.2847 11.6215 10.2292 11.5 10.2292C11.3785 10.2292 11.2812 10.2847 11.2083 10.3958L9.25 13L8.04167 11.3958C7.96875 11.2847 7.87153 11.2292 7.75 11.2292C7.62847 11.2292 7.53125 11.2847 7.45833 11.3958L5.96208 13.3965C5.86236 13.521 5.84896 13.6528 5.92188 13.7917C5.99479 13.9306 6.10417 14 6.25 14Z" />
  </svg>
);

export default IconImageFill;
